import { useCompanyCategoryFilter, useSessionMetricsFilters } from '@va/dashboard/shared/filters';
import { ApiOperators } from '@va/types/filters';
import { useMemo } from 'react';

export const useVisitsByCompanyFilterOptions = () => {
  const { allFilters } = useSessionMetricsFilters();
  const companyCategoryFilter = useCompanyCategoryFilter({
    valueMapper: () => ['isp'],
    operatorMapper: (_, values) => {
      const value = Array.isArray(values) ? values[0] : values;

      if (value === 'from') return ApiOperators.notIn;

      return ApiOperators.eq;
    },
  });

  return useMemo(() => [...allFilters, companyCategoryFilter], [allFilters, companyCategoryFilter]);
};
